<style lang="scss" scoped>
.body_search_box {
  padding: 20px;
  background-color: #fafafa;
  border-bottom: 1px solid #e0e3eb;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  .search_left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .search_item {
    display: flex;
    align-items: center;
    margin: 0px 10px 10px 0px;
  }

  .search_rigth {
    display: flex;

    .quick {
      width: 44px;
    }
  }

  // 兼容按钮模式
  .search_item_button {
    width: 340px;
  }

  // 兼容日期选择器
  .search_date_range {
    width: 320px;
  }

  .search_button {
    margin-left: 10px;
  }

  .search_main_color {
    font-size: 14px;
    color: #333333;
  }

  .searcg_info_color {
    font-size: 14px;
    color: #666666;
  }
}

.ml-0 {
  margin-left: 0px;
}

.ml-10 {
  margin-left: 10px;
}

@media screen and (max-width: 1660px) {
  .search_item {
    width: 150px;
  }
}
</style>
<template>
  <div ref="bodySearchBox" class="body_search_box">
    <div class="search_left">
      <slot name="searchLeft" />
      <slot v-if="show" name="searchItem" />
    </div>
    <div class="search_rigth">
      <div style="display: flex;align-items: baseline; margin-right: 10px;">
        <el-link v-if="linkShow" :underline="false" type="primary" class="quick" @click="display()"><i
          :class="show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        />{{ show ? '隐藏' : '更多' }}</el-link>
        <el-button
          :loading="loading"
          type="primary"
          size="small"
          :underline="false"
          :class="linkShow ? 'ml-10' : 'ml-0'"
          @click="search()"
        >查询</el-button>
      </div>
      <slot name="searchRigth" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseSearch',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: true,
      linkShow: true
    }
  },
  mounted() {
    // console.log(this.$scopedSlots)
    this.linkShow = !!this.$scopedSlots.searchItem
  },
  methods: {
    display() {
      this.show = !this.show
    },
    search() {
      this.$parent.search()
    }
  }
}
</script>
